export default "__VITE_ASSET__CvLlP7Nr__"